export const saskatoonTheme = {
  colors: {
    primary: 'rgba(0, 89, 78, 1)',
    primaryLight: 'rgba(166, 201, 193, 1)',
    primaryExtraLight: 'rgba(216, 233, 227, 1)',
    error: '#E84C3D',
    errorLight: 'rgba(232, 76, 61, 0.15)',
    white: '#FFFFFF',
    sectionDivider: '#CCCCCC',
    text: {
      body: '#000000',
      heading: 'rgba(0, 0, 0, 1)',
      link: 'rgba(0, 89, 78, 1)',
      linkDisabled: 'rgba(0, 89, 78, 0.6)'
    },
    primaryButton: {
      border: 'rgba(0, 89, 78, 1)',
      background: 'rgba(0, 89, 78, 1)',
      hover: 'rgba(0, 89, 78, 0.8)',
      disabled: 'rgba(0, 89, 78, 0.6)',
      text: '#FFFFFF',
      hoverText: '#FFFFFF',
      disabledText: '#FFFFFF'
    },
    secondaryButton: {
      border: 'rgba(0, 89, 78, 1)',
      hoverBorder: 'rgb(0, 89, 78, 1)',
      background: '#FFFFFF',
      hover: 'rgba(216, 233, 227, 1)',
      disabled: '#F7F7F7',
      text: 'rgba(0, 89, 78, 1)',
      disabledText: 'rgba(0, 89, 78, 0.8)'
    },
    inputField: {
      background: '#EEEEEE',
      border: 'rgba(84, 86, 91, 0.5)',
      focusedBorder: 'rgba(0, 89, 78, 1)',
      text: '#000000',
      placeholder: '#A6A6A6',
      disabledText: '#00000099'
    },
    background: {
      white: '#FFFFFF',
      light: '#F7F7F7',
      medium: '#EEEEEE',
      pageOverlay: 'rgba(85, 85, 85, 0.7)'
    }
  },
  borderRadius: {
    button: '4px',
    iconButton: '4px',
    div: '15px 0',
    input: '4px'
  },
  fonts: {
    heading: 'Montserrat, sans-serif',
    body: 'Montserrat, sans-serif'
  }
}
